import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../controllers/exams/ap_exmas";
import { list as academicsList } from "../../controllers/academics/academics";
import { fetchIpAddress } from "../../controllers/API";

import LoadingEffect from "../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : "");
  const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const handleNestedChange = (index, field, value, type) => {
    const updatedCodes = [...ADDEDITDATA[type]];
    updatedCodes[index][field] = value;
    setAddEditSata({ ...ADDEDITDATA, [type]: updatedCodes });
  };

  const addDigitalSatDates = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      digital_sat_dates: [
        ...(ADDEDITDATA.digital_sat_dates || []),
        { test_date: "", registration_deadline: "", changes_deadline: "" },
      ],
    });
  };
  const removeDigitalSatDates = (index) => {
    const updatedDigitalSatDates = [...ADDEDITDATA.digital_sat_dates];
    updatedDigitalSatDates.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, digital_sat_dates: updatedDigitalSatDates }));
  };

  const addUpcomingSatDates = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      upcoming_sat_dates: [
        ...(ADDEDITDATA.upcoming_sat_dates || []),
        { test_date: "", registration_deadline: "", changes_deadline: "" },
      ],
    });
  };
  const removeUpcomingSatDates = (index) => {
    const updatedUpcomingSatDates = [...ADDEDITDATA.upcoming_sat_dates];
    updatedUpcomingSatDates.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, upcoming_sat_dates: updatedUpcomingSatDates }));
  };

  const addDigitalPsat10Dates = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      digital_psat_10: [
        ...(ADDEDITDATA.digital_psat_10 || []),
        { test_date: "", registration_period: "" },
      ],
    });
  };
  const removeDigitalPsat10Dates = (index) => {
    const updatedDigitalPsat10Dates = [...ADDEDITDATA.digital_psat_10];
    updatedDigitalPsat10Dates.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, digital_psat_10: updatedDigitalPsat10Dates }));
  };

  const addDigitalPsat8_9Dates = () => {
    setAddEditSata({
      ...ADDEDITDATA,
      digital_psat_8_9: [
        ...(ADDEDITDATA.digital_psat_8_9 || []),
        { test_date: "", registration_period: "" },
      ],
    });
  };
  const removeDigitalPsat8_9Dates = (index) => {
    const updatedDigitalPsat8_9Dates = [...ADDEDITDATA.digital_psat_8_9];
    updatedDigitalPsat8_9Dates.splice(index, 1);
    setAddEditSata((prev) => ({ ...prev, digital_psat_8_9: updatedDigitalPsat8_9Dates }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        digital_sat_title,
        digital_sat_dates,
        upcoming_sat_title,
        upcoming_sat_dates,
        digital_psat_10_title,
        digital_psat_10,
        digital_psat_8_9_title,
        digital_psat_8_9
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("digital_sat_title", digital_sat_title);
      form.append("digital_sat_dates", digital_sat_dates);
      form.append("upcoming_sat_title", upcoming_sat_title);
      form.append("upcoming_sat_dates", upcoming_sat_dates);
      form.append("digital_psat_10_title", digital_psat_10_title);
      form.append("digital_psat_10", digital_psat_10);
      form.append("digital_psat_8_9_title", digital_psat_8_9_title);
      form.append("digital_psat_8_9", digital_psat_8_9);

      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const rawData = {
          edit_id: _id,
          digital_sat_title, digital_sat_title,
          digital_sat_dates, digital_sat_dates,
          upcoming_sat_title, upcoming_sat_title,
          upcoming_sat_dates, upcoming_sat_dates,
          digital_psat_10_title, digital_psat_10_title,
          digital_psat_10, digital_psat_10,
          digital_psat_8_9_title, digital_psat_8_9_title,
          digital_psat_8_9, digital_psat_8_9
        }
        const options = {
          url: "sat-exams/addeditdata",
          postData: rawData,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/sat-exams");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormData = (form) => {
    if (!form.get("digital_sat_title") || form.get("digital_sat_title") === "undefined" || form.get("digital_sat_title") === null) {
      setError((preError) => ({
        ...preError,
        digital_sat_title: "Title is required",
      }));
      return false;
    }
    if (!form.get("upcoming_sat_title") || form.get("upcoming_sat_title") === "undefined" || form.get("upcoming_sat_title") === null) {
      setError((preError) => ({
        ...preError,
        upcoming_sat_title: "Title is required",
      }));
      return false;
    }
    if (!form.get("digital_psat_10_title") || form.get("digital_psat_10_title") === "undefined" || form.get("digital_psat_10_title") === null) {
      setError((preError) => ({
        ...preError,
        digital_psat_10_title: "Title is required",
      }));
      return false;
    }
    if (!form.get("digital_psat_8_9_title") || form.get("digital_psat_8_9_title") === "undefined" || form.get("digital_psat_8_9_title") === null) {
      setError((preError) => ({
        ...preError,
        digital_psat_8_9_title: "Title is required",
      }));
      return false;
    }
    return true;
  };


  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } SAT Exams`;
  }, []);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} SAT Exams
            </h5>
          </div>
          <Link to="/sat-exams">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <h4 className="mt-5">Digital SAT Dates</h4>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="digital_sat_title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Digital SAT title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="digital_sat_title"
                      className="form-control store_input_field"
                      id="digital_sat_title"
                      value={ADDEDITDATA?.digital_sat_title}
                      onChange={handleChange}
                    />
                    {error.digital_sat_title ? (
                      <p style={{ color: "red" }}>
                        {error.digital_sat_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <button type="button" onClick={addDigitalSatDates} className="btn btn-primary">Add Item</button>
                  </div>
                  {ADDEDITDATA?.digital_sat_dates?.map((digital_sat_date, digital_sat_dates_index) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={digital_sat_dates_index}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test date :{" "}
                          </label>
                          <input
                            placeholder="Test date"
                            value={digital_sat_date.test_date}
                            onChange={(e) =>
                              handleNestedChange(digital_sat_dates_index, "test_date", e.target.value, "digital_sat_dates")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Registration deadline :{" "}
                          </label>
                          <input
                            placeholder="Registration deadline"
                            value={digital_sat_date.registration_deadline}
                            onChange={(e) =>
                              handleNestedChange(digital_sat_dates_index, "registration_deadline", e.target.value, "digital_sat_dates")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Changes deadline :{" "}
                          </label>
                          <input
                            placeholder="Changes deadline"
                            value={digital_sat_date.changes_deadline}
                            onChange={(e) =>
                              handleNestedChange(digital_sat_dates_index, "changes_deadline", e.target.value, "digital_sat_dates")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeDigitalSatDates(digital_sat_dates_index)} className="btn btn-primary">Remove Item</button>
                        </div>
                      </div>
                    </div>
                  ))}

                  <h4 className="mt-5">Upcoming SAT details</h4>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="upcoming_sat_title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Upcoming SAT title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="upcoming_sat_title"
                      className="form-control store_input_field"
                      id="upcoming_sat_title"
                      value={ADDEDITDATA?.upcoming_sat_title}
                      onChange={handleChange}
                    />
                    {error.upcoming_sat_title ? (
                      <p style={{ color: "red" }}>
                        {error.upcoming_sat_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <button type="button" onClick={addUpcomingSatDates} className="btn btn-primary">Add Item</button>
                  </div>
                  {ADDEDITDATA?.upcoming_sat_dates?.map((upcoming_sat_date, upcoming_sat_datesIndex) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={upcoming_sat_datesIndex}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test date :{" "}
                          </label>
                          <input
                            placeholder="Test date"
                            value={upcoming_sat_date.test_date}
                            onChange={(e) =>
                              handleNestedChange(upcoming_sat_datesIndex, "test_date", e.target.value, "upcoming_sat_dates")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Registration deadline :{" "}
                          </label>
                          <input
                            placeholder="Enter Registration deadline"
                            value={upcoming_sat_date.registration_deadline}
                            onChange={(e) =>
                              handleNestedChange(upcoming_sat_datesIndex, "registration_deadline", e.target.value, "upcoming_sat_dates")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Changes deadline :{" "}
                          </label>
                          <input
                            placeholder="Enter Changes deadline"
                            value={upcoming_sat_date.changes_deadline}
                            onChange={(e) =>
                              handleNestedChange(upcoming_sat_datesIndex, "changes_deadline", e.target.value, "upcoming_sat_dates")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeUpcomingSatDates(upcoming_sat_datesIndex)} className="btn btn-primary">Remove Item</button>
                        </div>
                      </div>
                    </div>
                  ))}

                  <h4 className="mt-5">Digital PSAT 10 details</h4>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="digital_psat_10_title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Digital PSAT title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="digital_psat_10_title"
                      className="form-control store_input_field"
                      id="digital_psat_10_title"
                      value={ADDEDITDATA?.digital_psat_10_title}
                      onChange={handleChange}
                    />
                    {error.digital_psat_10_title ? (
                      <p style={{ color: "red" }}>
                        {error.digital_psat_10_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <button type="button" onClick={addDigitalPsat10Dates} className="btn btn-primary">Add Item</button>
                  </div>
                  {ADDEDITDATA?.digital_psat_10?.map((digital_psat_10, digital_psat_10Index) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={digital_psat_10Index}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test date :{" "}
                          </label>
                          <input
                            placeholder="Test date"
                            value={digital_psat_10.test_date}
                            onChange={(e) =>
                              handleNestedChange(digital_psat_10Index, "test_date", e.target.value, "digital_psat_10")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Registration Period :{" "}
                          </label>
                          <input
                            placeholder="Enter Registration Period"
                            value={digital_psat_10.registration_period}
                            onChange={(e) =>
                              handleNestedChange(digital_psat_10Index, "registration_period", e.target.value, "digital_psat_10")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeDigitalPsat10Dates(digital_psat_10Index)} className="btn btn-primary">Remove Item</button>
                        </div>
                      </div>
                    </div>
                  ))}


                  <h4 className="mt-5">Digital PSAT 8/9 details</h4>
                  <hr></hr>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="digital_psat_8_9_title"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Digital PSAT 8/9 title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="digital_psat_8_9_title"
                      className="form-control store_input_field"
                      id="digital_psat_8_9_title"
                      value={ADDEDITDATA?.digital_psat_8_9_title}
                      onChange={handleChange}
                    />
                    {error.digital_psat_8_9_title ? (
                      <p style={{ color: "red" }}>
                        {error.digital_psat_8_9_title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-2">
                    <button type="button" onClick={addDigitalPsat8_9Dates} className="btn btn-primary">Add Item</button>
                  </div>
                  {ADDEDITDATA?.digital_psat_8_9?.map((digital_psat_8_9, digital_psat_8_9Index) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" key={digital_psat_8_9Index}>
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-4-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Test date :{" "}
                          </label>
                          <input
                            placeholder="Test date"
                            value={digital_psat_8_9.test_date}
                            onChange={(e) =>
                              handleNestedChange(digital_psat_8_9Index, "test_date", e.target.value, "digital_psat_8_9")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-3 col-md-3-sm-12 col-xs-12 vendor_Add_edit_data">
                          <label className="all_section_for_label_main_class all_lebel_margin_top_main_div">
                            <span style={{ color: "red" }}>*</span>Registration Period :{" "}
                          </label>
                          <input
                            placeholder="Enter Registration Period"
                            value={digital_psat_8_9.registration_period}
                            onChange={(e) =>
                              handleNestedChange(digital_psat_8_9Index, "registration_period", e.target.value, "digital_psat_8_9")
                            }
                            type="text"
                            className="form-control store_input_field"
                          />
                        </div>
                        <div className="form-group col-lg-2 col-md-2 col-sm-12 col-xs-12 vendor_Add_edit_data mt-5">
                          <button type="button" onClick={() => removeDigitalPsat8_9Dates(digital_psat_8_9Index)} className="btn btn-primary">Remove Item</button>
                        </div>
                      </div>
                    </div>
                  ))}

                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
